var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { inActive: !_vm.user.is_active } }, [
    _c(
      "p",
      [
        _vm._v(_vm._s(_vm.user.name) + " (" + _vm._s(_vm.user.id) + ")\n    "),
        _vm.getDetailByAlias(_vm.user, "telegram_chat_data")
          ? [_c("i", { staticClass: "icon-fa icon-fa-paper-plane color_blue" })]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("p", { staticClass: "phone" }, [_vm._v(_vm._s(_vm.user.phone))]),
    _vm._v(" "),
    _vm.getDetailByAlias(_vm.user, "comment")
      ? _c("p", { staticClass: "comment" }, [
          _vm._v(_vm._s(_vm.getDetailByAlias(_vm.user, "comment"))),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }